import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import "./Terms.css";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const [content, setContent] = useState("");
  const { i18n } = useTranslation();

  useEffect(() => {
    const file =
      i18n.language.startsWith("el")
        ? process.env.PUBLIC_URL + "/terms_el.md"
        : process.env.PUBLIC_URL + "/terms.md";

    fetch(file)
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, [i18n.language]);

  return (
    <div className="termsPage">
      <div className="termsContainer">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
};

export default Terms;
